import React from "react";
import { hexToRgba } from "./colorUtils";

export const ProductPill = ({ product, className = "", testId }) => {
  if (!product) return null;
  const { name, hex, slug } = product;
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-[11px] font-semibold leading-none ${className}`}
      style={{
        background: hexToRgba(hex, 0.12),
        color: "hsl(var(--foreground))",
        borderColor: hexToRgba(hex, 0.35),
      }}
      data-testid={testId || `product-pill-${slug}`}
    >
      <span className="inline-block w-2 h-2 rounded-full" style={{ background: hex }} aria-hidden />
      {name}
    </span>
  );
};

export default ProductPill;
